<fui-filter-fascia [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()" [hovered]="hovered">
    <fui-fixtures>
        <fui-fixture>
            <fui-filter-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                              [title]="label" [i18NParams]="labelI18NParams" [valued]="valued"></fui-filter-label>
        </fui-fixture>
    </fui-fixtures>
    <fui-fixtures>
        @if (icon) {
            <fui-fixture>
                <ng-content select="fui-icon"></ng-content>
            </fui-fixture>
        }
        @if (!icon) {
            <fui-fixture>
                <fui-icon [height]="12" [icon]="'lookup'" [width]="12"></fui-icon>
            </fui-fixture>
        }
        <fui-spanning-fixture>
            <fui-input-dom>
                <input (blur)="onBlur($event)" [disabled]="disabled" #input (focus)="onFocus($event)"
                       [readonly]="readonly"
                       [(ngModel)]="value"
                       [placeholder]="placeholder | translate" [tabindex]="tabindex" type="text">
            </fui-input-dom>
        </fui-spanning-fixture>
    </fui-fixtures>
</fui-filter-fascia>
